import ButtonAction from '../../../../components/buttons/ButtonAction';
import { EditIcon, TrashOutlineIcon } from '../../../../components/buttons/IconButtons';
import HeadTittle from '../../../../components/HeadTittle';
import EquipmentAndMaterialApp from './Functionality/EquipmentAndMaterialApp';
import { VIEW_TYPE } from '../../../../enums/ViewType';
import DeleteModal from '../../../Modals/DeleteModal';
import ExportDataBtn from '../../../../components/buttons/ExportDataBtn';
import EquipmentAndMaterialCards from './subComponents/EquipmentAndMaterialCards';
import EquipmentAndMaterialTable from './subComponents/EquipmentAndMaterialTable';

/**
 * @Author      Susana García Rodriguez
 * @JobTitle    Frontend Developer
 * @Email       sgarcia@ibl.mx
 */

const EquipmentAndMaterial = () => {
    const {
        t,
        handleCreate,
        deleteModalShow,
        handleDeleteSelected,
        toggleModal,
        selectForDelete,
        isAllChecked,
        setIsAllChecked,
        moduleId,
        search,
        bodyForExport,
        setBodyForExport,
        option,
        view,
        setView,
        setSearch,
        setSelectForDelete,
        setDeleteModalShow,
        modified,
        setModified,
        contractorId,
        supplierId,

    } = EquipmentAndMaterialApp({});

    return (
        <>
            <HeadTittle  name={t('equipment_material_control')}>
                <>
                    <ExportDataBtn moduleId={moduleId} body={bodyForExport} option={option} search={search} />
                    <ButtonAction
                        id='btn_eam_create_data'
                        name='create'
                        className='btn-icon-edit'
                        Icon={EditIcon}
                        onClick={handleCreate}
                    />

                    <ButtonAction
                        id='btn_eam_delete'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectForDelete?.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={() => toggleModal()}
                    />
                </>
            </HeadTittle>
            {view === VIEW_TYPE.LIST.name && (
                <EquipmentAndMaterialTable
                    selectForDelete={selectForDelete}
                    isAllChecked={isAllChecked}
                    setIsAllChecked={setIsAllChecked}
                    setSearch={setSearch}
                    view={view}
                    setBodyForExport={setBodyForExport}
                    setView={setView}
                    setSelectForDelete={setSelectForDelete}
                    setDeleteModalShow={setDeleteModalShow}
                    modified={modified}
                    setModified={setModified}
                    contractorId={contractorId}
                    supplierId={supplierId}
                />
            )}

            {view === VIEW_TYPE.GRID.name && (
                <EquipmentAndMaterialCards
                    selectForDelete={selectForDelete}
                    isAllChecked={isAllChecked}
                    setIsAllChecked={setIsAllChecked}
                    setSearch={setSearch}
                    view={view}
                    setBodyForExport={setBodyForExport}
                    setView={setView}
                    setSelectForDelete={setSelectForDelete}
                    setDeleteModalShow={setDeleteModalShow}
                    modified={modified}
                    setModified={setModified}
                    contractorId={contractorId}
                    supplierId={supplierId}
                   
                />
            )}

            {deleteModalShow && (
                <DeleteModal
                    show={deleteModalShow}
                    onHide={() => toggleModal()}
                    onClickFn={() => handleDeleteSelected()}
                    data={selectForDelete}
                    isReset={setSelectForDelete}
                    isAllReset={setIsAllChecked}
                    title_modal={t('delete_equipment_material')}
                    description={'are_you_sure_you_want_to_delete'}
                    element_modal={t('equipment_material')}
                    buttonCancelText={'cancel'}
                />
            )}
        </>
    );
};

export default EquipmentAndMaterial;
